import * as React from 'react';
import { GroupedCardItem } from '@grandvisionhq/content';
import { Container, Heading } from '@grandvisionhq/elements';
import { compose } from '@grandvisionhq/utils';
import { useBloomreachGroupCardsData } from '../../hooks/use-bloomreach-group-cards-data.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withAnchor } from '../../hocs/with-anchor.js';

const CmsGroupedCards = ({ component  })=>{
    const { pageable  } = component.getModels();
    const { title  } = component.getParameters();
    const documentDataWithRef = useBloomreachGroupCardsData(pageable);
    return /*#__PURE__*/ React.createElement(Container, {
        className: "group-cards"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "small"
    }, title), documentDataWithRef.map((item, index)=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: index
        }, /*#__PURE__*/ React.createElement(GroupedCardItem, {
            icon: item.icon,
            header: item.header,
            content: item.content,
            url: item.url,
            urlText: item.urlText
        }))
    ));
};
var GroupedCards = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsGroupedCards);

export { CmsGroupedCards, GroupedCards as default };
//# sourceMappingURL=GroupedCards.js.map
